module.exports = __webpack_public_path__ + "static/media/hero2.1766229e.png";